module.exports = __webpack_public_path__ + "media/images/ep4-cindy-c1e6ee90e68ae7cbd707b21f447d67cf.png";